import React, { useEffect, useState } from 'react'
import './nav-menu.scss'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import getUserInfo from '../../../utils/getUserInfo'
import { jsonToHash } from '../../../utils/crypto'
import Show from '../../../utils/show'
import { LOCALE } from '../../../constants/activity-constants'

const haveTop = () => {
  return !['es-AR'].includes(LOCALE)
}
const userInfo = getUserInfo()
const pushTagInfo = async evt => {
  if (evt) {
    let text = evt.target?.textContent
    if (text) {
      pushEventData({
        event: 'Interacciones_Menú_RompeTabus',
        label: text,
        user_data: userInfo && [
          await jsonToHash({
            nombre: userInfo.name,
            apellido: userInfo.lastName,
            celular: userInfo.cellPhone,
            correo: userInfo.email,
            ciudad: userInfo.location.cityName,
            departamento: userInfo.location.countryStateName,
            pais: userInfo.countryName,
          }),
        ],
        log_status: userInfo ? 'Yes' : 'Not',
      })
    }
  }
}

export const NavLink = ({ hash, href, children, id }) => {
  return (
    <li
      className={
        'f-navMenu__list__item' +
        (hash === href ? ' --active' : '') +
        (!haveTop() ? ' --halfWidth' : '')
      }
    >
      <a
        onClick={pushTagInfo}
        href={href}
        className="f-navMenu__list__item --btn-url"
        id={id}
      >
        {children}
      </a>
    </li>
  )
}
const NavMenu = () => {
  const [hash, setHash] = useState('')

  useEffect(() => {
    if (typeof window != 'undefined') {
      setHash(window.location.hash)
      const listener = () => {
        setHash(window.location.hash)
        let element = document.querySelector(window.location.hash)
        if (element) {
          document.scrollingElement.scroll(0, element.offsetTop - 60)
        }
      }
      window.addEventListener('hashchange', listener, false)
      return () => {
        window.removeEventListener('hashchange', listener)
      }
    }
  }, [])
  return (
    <nav className={'f-navMenu ' + (!haveTop() ? ' --smaller ' : '')}>
      <ul className="f-navMenu__list">
        <NavLink hash={hash} href={'#inicio'} id={'link-inicio'}>
          Inicio
        </NavLink>
        <NavLink hash={hash} href={'#participate'} id={'link-participate'}>
          ¿Como Participar?
        </NavLink>
        <Show valid={haveTop()}>
          <NavLink hash={hash} href={'#top'} id={'link-top'}>
            Top Jugadoras
          </NavLink>
        </Show>
      </ul>
    </nav>
  )
}

export default NavMenu
